import { render, staticRenderFns } from "./v-content.vue?vue&type=template&id=ccb8a368&scoped=true&"
import script from "./v-content.vue?vue&type=script&lang=js&"
export * from "./v-content.vue?vue&type=script&lang=js&"
import style0 from "./v-content.vue?vue&type=style&index=0&id=ccb8a368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb8a368",
  null
  
)

export default component.exports